import { HttpErrorResponse } from '@angular/common/http';
import {
  AbstractControl,
  FormGroup,
  NgForm,
  ValidationErrors,
} from '@angular/forms';

export function handleFormHttpError(
  res: HttpErrorResponse,
  form: NgForm | FormGroup
) {
  const errors: ValidationErrors = res.error.errors;

  for (const [key, value] of Object.entries(errors)) {
    let control: AbstractControl;

    if (form instanceof FormGroup) {
      control = form.get(key);
    } else if (form instanceof NgForm) {
      control = form.controls[key];
    } else {
      throw new TypeError(
        'server-errors-form-handler must be used with a ngForm or formGroup directive'
      );
    }

    if (control) {
      control.setErrors({ serverError: value });
    } else {
      if (form['submitted']) {
        (<any>form).errors = null;
      }
      if (!form.errors) {
        (<any>form).errors = { serverError: [] };
      }

      (<any>form).errors.serverError.push(value);
    }
  }
}
